import React, { useEffect } from 'react';
import {
    DataGridPro,
    GridEventListener,
    GridToolbarContainer,
    useGridApiContext,
    useGridApiRef,
    gridVisibleSortedRowIdsSelector,
    GridCsvExportOptions,
    GridCsvGetRowsToExportParams,
    GridToolbarColumnsButton,
    GridToolbarFilterButton,
    GridColumnMenuContainer,
    GridFilterMenuItem,
    SortGridMenuItems,
    HideGridColMenuItem,
    GridColumnsMenuItem,
    GridSelectedRowCount
} from '@mui/x-data-grid-pro';
import setLicenseKey from './DataGridLicense'
import { ReactComponent as GridColumnsIcon } from '../../assests/icons/Grid_column.svg'
import { ReactComponent as GridFilterIcon } from '../../assests/icons/Grid_filter.svg'
import { ReactComponent as GridExportIcon } from '../../assests/icons/Grid_export.svg'
import EditOutlinedIcon from '@mui/icons-material/EditOutlined';
import DeleteOutlineOutlinedIcon from '@mui/icons-material/DeleteOutlineOutlined';
import ContentPasteOutlinedIcon from '@mui/icons-material/ContentPasteOutlined';
import ContentPasteOffOutlinedIcon from '@mui/icons-material/ContentPasteOffOutlined';
import RemoveRedEyeOutlinedIcon from '@mui/icons-material/RemoveRedEyeOutlined';
import ContentCopyOutlinedIcon from '@mui/icons-material/ContentCopyOutlined';
import ShareOutlinedIcon from '@mui/icons-material/ShareOutlined';
import MoreVertIcon from "@mui/icons-material/MoreVert";
import { GlobalStyles, CircularProgress } from '@mui/material';
import Button, { ButtonProps } from '@mui/material/Button';
import GenericModal from '../../components/Modal/GenericModal'
import BrandingColors from '../../styles/color';
import Tooltip from '@mui/material/Tooltip';
import Stack from '@mui/material/Stack';
import Paper from '@mui/material/Paper';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import { Add } from '@material-ui/icons';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import HighlightOffIcon from '@mui/icons-material/HighlightOff';
import { formatDate, formatDateTime } from '../../helper';
import { formatToFixed } from '../../helper/formatToFixed';
import { useSelector } from 'react-redux';
import { tablePaginationSelector, updateTableSelector } from '../../redux/common/tableTracker/selectors';


const getFilteredRows = ({ apiRef }: GridCsvGetRowsToExportParams) =>
    gridVisibleSortedRowIdsSelector(apiRef);

const ElementsDataGridToolbar = (props) => {
    const { selectionModel, selectionModelIds, onEdit, onDelete, deleteDisable, onEnable, onView, onCopy, onShare, initialSorting, trackingLabel, selectionModelRow,
        addEditAccess, shareAccess, viewAccess, onAdd, isDelete = true, hideFooterSelectedRowCount, showDownload = true, onMoreActions, moreActionsAccess, onWorkflowAction, 
        deleteConfirmTitle,approvalActions, approvalActionsAccess } = props;
    const apiRef = useGridApiContext();
    const defaultDeleteConfirmTitle = deleteConfirmTitle ? deleteConfirmTitle : "Are you sure you want to delete? ";
    const [confirmOpen, setConfirmOpen] = React.useState(false);
    const [shareChecked, setShareChecked] = React.useState(false);

    const handleExport = (options: GridCsvExportOptions) =>
        apiRef.current.exportDataAsCsv(options);

    const buttonBaseProps: ButtonProps = {
        color: 'primary',
        size: 'small'
    };

    

    const disabledIcon = !selectionModel || selectionModel.length !== 1
    
    return (
        <GridToolbarContainer>
            {hideFooterSelectedRowCount && selectionModel?.length >= 1 &&
                <GridSelectedRowCount className="RowSelectedCount" selectedRowCount={selectionModel?.length} />
            }
            {showDownload && <Tooltip title={`Export ${trackingLabel || 'table'} to CSV`} arrow><Button
                {...buttonBaseProps}
                aria-label={`Export ${trackingLabel || 'table'} to CSV`}                
                startIcon={<GridExportIcon />}
                onClick={() => {
                    handleExport({ getRowsToExport: getFilteredRows, fileName: trackingLabel })
                }} >
            </Button></Tooltip>
            }
            <Tooltip title="Show or hide columns" arrow><GridToolbarColumnsButton aria-label='Show/Hide Columns' startIcon={<GridColumnsIcon aria-hidden="true" focusable="false"/>} /></Tooltip>
            <GridToolbarFilterButton
                componentsProps={{
                    button: {
                        'aria-label': 'Filter rows',
                        startIcon: (
                            <GridFilterIcon aria-hidden="true" focusable="false"/>
                        )
                    }
                }}
            />
            {onCopy && addEditAccess &&
                <Tooltip title="Copy" arrow>
                    <span><Button
                        {...buttonBaseProps}                        
                        aria-label="Copy"
                        startIcon={<ContentCopyOutlinedIcon color={disabledIcon ? "disabled" : ""}
                            style={{ pointerEvents: disabledIcon ? 'none' : "" }} />}
                        sx={{
                            '&.Mui-disabled': {
                                background: 'none !important'
                            }
                        }}
                        disabled={disabledIcon}
                        onClick={(e) => { onCopy(selectionModelRow[0]); }}
                    ></Button></span></Tooltip>}
            {onEnable && addEditAccess &&
                <Tooltip title={selectionModel?.length >= 1 ? (selectionModelRow[0]?.isActive === true || selectionModelRow[0]?.isActive === 'Yes') ? "Disable" : "Enable" : "Enable/Disable"} arrow>
                    <span><Button
                        {...buttonBaseProps}
                        aria-label={selectionModel?.length >= 1 ? ((selectionModelRow[0]?.isActive === true || selectionModelRow[0]?.isActive === 'Yes') ? 'Disable' : 'Enable') : 'Enable/Disable'}
                        startIcon={selectionModel?.length >= 1 ? (selectionModelRow[0]?.isActive === true || selectionModelRow[0]?.isActive === 'Yes') ? <ContentPasteOffOutlinedIcon /> : <ContentPasteOutlinedIcon />
                            : <ContentPasteOffOutlinedIcon color={disabledIcon ? "disabled" : ""}
                                style={{ pointerEvents: disabledIcon ? 'none' : "" }} />}
                        sx={{
                            '&.Mui-disabled': {
                                background: 'none !important'
                            }
                        }}
                        disabled={disabledIcon}
                        onClick={(e) => { onEnable(selectionModelRow[0]); }}
                    ></Button></span></Tooltip>}
            {onDelete && addEditAccess &&
                <Tooltip title="Delete" arrow><span> <Button
                    {...buttonBaseProps}
                    aria-label="Delete selected row"
                    className={deleteDisable ? 'disableDeleteButton' : ''}
                    startIcon={<DeleteOutlineOutlinedIcon color={disabledIcon ? "disabled" : ""}
                        style={{ pointerEvents: disabledIcon ? 'none' : "" }} />}
                    sx={{
                        '&.Mui-disabled': {
                            background: 'none !important'
                        }
                    }}
                    disabled={disabledIcon}
                    onClick={() => {
                        setConfirmOpen(true);
                        /* Funtion not Implemented */
                        // setConfirmOpen(isDelete);
                        // onDelete(selectionModelRow[0]);
                    }}>
                </Button></span></Tooltip>}
            {onEdit && addEditAccess &&
                <Tooltip title="Edit" arrow><span><Button
                    {...buttonBaseProps}
                    aria-label="Edit selected row"
                    startIcon={<EditOutlinedIcon color={disabledIcon ? "disabled" : ""}
                        style={{ pointerEvents: disabledIcon ? 'none' : "" }} />}
                    sx={{
                        '&.Mui-disabled': {
                            background: 'none !important'
                        }
                    }}
                    disabled={disabledIcon}
                    onClick={(e) => { onEdit(selectionModelRow[0]); }} >
                </Button></span></Tooltip>}
            {onAdd && addEditAccess && <Tooltip title="Add" arrow><Button
                {...buttonBaseProps}
                aria-label="Add new row"
                startIcon={<Add />}
                onClick={(e) => { onAdd(); }} >
            </Button></Tooltip>}
            {onView && viewAccess &&
                <Tooltip title="View" arrow>
                    <span><Button
                        {...buttonBaseProps}
                        startIcon={<RemoveRedEyeOutlinedIcon color={disabledIcon ? "disabled" : ""}
                            style={{ pointerEvents: disabledIcon ? 'none' : "" }} />}
                        sx={{
                            '&.Mui-disabled': {
                                background: 'none !important'
                            }
                        }}
                        disabled={disabledIcon}
                        onClick={(e) => { onView(selectionModelRow[0]); }}
                    ></Button></span></Tooltip>}

            {approvalActions &&
                <>
                    <Tooltip title="Approve" arrow>
                        <Button
                            {...buttonBaseProps}
                            aria-label="Approve"
                            startIcon={<CheckCircleOutlineIcon />}
                            onClick={() => approvalActions("APPROVE")}
                            disabled={!approvalActionsAccess}
                        >
                        </Button>
                    </Tooltip>
                    <Tooltip title="Reject" arrow>
                        <Button
                            {...buttonBaseProps}
                            aria-label="Reject"
                            startIcon={<HighlightOffIcon />}
                            onClick={() => approvalActions("REJECT")}
                            disabled={!approvalActionsAccess}
                        >
                        </Button>
                    </Tooltip>
                </>

            }
            {onMoreActions && moreActionsAccess &&
                <Tooltip title="More Actions" arrow>
                    <Button
                        {...buttonBaseProps}
                        aria-label="More Actions"
                        startIcon={<MoreVertIcon />}
                        onClick={onMoreActions}
                    >
                    </Button>
                </Tooltip>
            }
            {selectionModel?.length >= 1 && onShare && shareAccess &&
                <>
                    <Tooltip title="Share" arrow><Button
                        {...buttonBaseProps}
                        aria-label="Share"
                        startIcon={<ShareOutlinedIcon />}
                        onClick={(e) => {
                            // onShare(selectionModelRow[0]); 
                            setShareChecked((prev) => !prev);
                        }}
                    ></Button></Tooltip>
                    {shareChecked &&
                        <Paper style={{
                            position: 'absolute',
                            zIndex: '1',
                            top: '50px',
                            right: '140px'
                        }}>
                            <List>
                                <ListItem>
                                    Copy Link
                                </ListItem>
                                <ListItem>
                                    Send Email
                                </ListItem>
                            </List>
                        </Paper>
                    }
                </>
            }
            <GenericModal
                open={confirmOpen}
                title={defaultDeleteConfirmTitle}
                buttonText={"Yes"}
                button2Text={"No"}
                onButtonPress={() => {
                    onDelete(selectionModelRow);
                }}
                onClose={setConfirmOpen}
            />
        </GridToolbarContainer>
    );
};

const ElementsColumnMenu = (props) => {
    const { hideMenu, currentColumn } = props;
    return (
        <GridColumnMenuContainer
            hideMenu={hideMenu}
            currentColumn={currentColumn}
        >
            <SortGridMenuItems onClick={hideMenu} column={currentColumn} />
            <GridFilterMenuItem onClick={hideMenu} column={currentColumn} />
            <HideGridColMenuItem onClick={hideMenu} column={currentColumn} />
            <GridColumnsMenuItem onClick={hideMenu} column={currentColumn} />
        </GridColumnMenuContainer>
    )
}

export default function ElementsDataGridPro(props) {

    const { isLoading,
        multiSelect,
        headCells,
        initialSorting,
        rows,
        hideCheckBox,
        actionCols,
        pagination,
        onDelete,
        deleteDisable,
        onEdit,
        onEnable,
        onView,
        onCopy,
        onShare,
        isLookup,
        onRowSelect,
        actionFlag,
        trackingLabel,
        dataGridToolbar,
        dataGridColumnMenus,
        hideFooterSelectedRowCount = false,
        addEditAccess,
        shareAccess,
        viewAccess,
        onAdd,
        isDelete,
        showDownload = true,
        onMoreActions,
        moreActionsAccess,
        defaultColumns = {},
        onWorkflowAction,
        selectionModelChanged,
        columnVisibilityModel: externalColumnVisibilityModel,
        onColumnVisibilityModelChange: onExternalColumnVisibilityModelChange,
        emptyRowsMessage = 'No Data Available',
        emptyResultsMessage = 'No Data Available',
        autoHeight = true,
        colMinWidth,
        resetGridSelection = false,
        approvalActions,
        approvalActionsAccess,
        deleteConfirmTitle=null,
        nestedTable = false,
        DetailPanelContentFn = null,
        DetailPanelHeightCustom = null,
        onRowDoubleClick,
        onRowRightClick,
        isRowSelectable,
        getRowClassName,
        sxOverride,
        onRowUpdate,
        editMode,
        apiRef: externalApiRef,
        clearModifiedRows,
        key = 0      
    } = props;

    const { defaultValueRowsperPage }= useSelector(tablePaginationSelector);


    setLicenseKey()
    const [page, setPage] = React.useState(0)
    const [pageSize, setPageSize] = React.useState(20)
    const maxVisibleRows = 8
    const [modifiedRows, setModifiedRows] = React.useState({});
    const modifiedRowsRef = React.useRef({}); 
    const pendingUpdateResolvers = React.useRef([]);
    const editingRowIdRef = React.useRef(null); 

    // cleanup pending resolvers on unmount to prevent memory leaks for the editable grids.
    React.useEffect(() => {
        return () => {
            pendingUpdateResolvers.current = [];
        };
    }, []);

    const getValueFormatter = (type) => {
        switch (type?.toLowerCase())
        {
            case "datetime":
                return (params) => {
                    if (params.value) {
                        return formatDateTime(params.value)
                    }
                    return '';
                }            
            case "date":
                return (params) => {
                    if (params.value) {
                        return formatDate(params.value)
                    }
                    return '';
                }            

            case 'float':
                return (params) => {
                    if (params.value !== null && params.value !== undefined) {
                        return formatToFixed(params.value);
                    }
                    return '';
                }
            
            case 'boolean':
                return (params) => {                    
                    if (params.value != null && params.value === true) {
                        return "Yes" 
                        
                    }
                    else return  "No"
                }
        }            
        return undefined;            
    }

    const dgColumns = [
        // ...(((!isLookup && !multiSelect) && !hideCheckBox) && !nestedTable
        //     ? [{
        //         field: "",
        //         headerName: "",
        //         disableColumnMenu: true,
        //         disableExport: true,
        //         sortable: false,
        //         resizable: false,
        //         hideable: false,
        //         filterable: false,
        //         width: 50,
        //         renderCell: (params) => (
        //             !hideCheckBox && (
        //                 <Checkbox
        //                     checked={rowChecked != null && params != null && rowChecked[0] === params.id}
        //                     value={params != null ? params.id : null}
        //                 />))
        //     }]
        //     : []
        // ),
        ...headCells.map(headCell => {
            const cellType = headCell.type?.toLowerCase();
            return {
            ...headCell, // Copies all properties from headCell
            field: headCell.id,
            sortable: headCell.sortable ?? true,
            editable: headCell.editable ?? false,
            filterable: headCell.filterable ?? true,
            headerName: headCell.label ,
            disableColumnMenu: !dataGridColumnMenus,
            valueFormatter: headCell.valueFormatter,
            renderCell: headCell.renderCell,
            cellClassName: headCell.editable
                ? `editable-cell ${cellType === 'singleselect' ? 'editable-select' : cellType === 'date' ? 'editable-date' : 'editable-text'}`
                : '',
            flex: headCell.width ? undefined : (headCell.flex === undefined ? undefined : headCell.flex),
            type: headCell.type,
            align: headCell.align,
            headerAlign: headCell.headerAlign,
            width: headCell.width ?? ((headCell.label.length * 12) + 40),    
            minWidth: headCell.minWidth ?? (colMinWidth ? colMinWidth : ((headCell.label.length * 12) + 40)),
            hide: headCell.hide ?? false,
            valueFormatter : getValueFormatter(headCell.type),
            valueOptions: headCell.valueOptions ?? undefined,
        }})
    ]

    const isEditable = headCells.some(cell => cell.editable);

    actionCols?.map((col, index) => (
        dgColumns.push({
            id: index,
            ...col
        })))

    const dgRows = rows.map((row, index) => ({
        id: index,
        ...row
    }))

    const displayToolbar = dataGridToolbar ? "block" : "none"

    const handleRowClick: GridEventListener<'rowClick'> = (params) => {
        (onRowSelect) && onRowSelect(params.row);

        // making this a Single-click edit mode instead of double click to make it more fluid
        if (isEditable && editMode === 'row') {            
            const previousEditingId = editingRowIdRef.current;
            if (previousEditingId !== null && previousEditingId !== params.id) {
                apiRef.current.stopRowEditMode({ id: previousEditingId, ignoreModifications: false });
            }

            // editing mode, engaged...
            editingRowIdRef.current = params.id;
            apiRef.current.startRowEditMode({ id: params.id });
        }
    }

    const handleProcessRowUpdate = React.useCallback(
        async (newRow, oldRow) => {
            try {
                // Track modified rows
                const rowId = newRow.id;
                const hasChanges = Object.keys(newRow).some(key =>
                    key !== 'id' && newRow[key] !== oldRow[key]
                );
            
                if (hasChanges) {
                    modifiedRowsRef.current[rowId] = newRow;

                    setModifiedRows(prev => ({
                        ...prev,
                        [rowId]: newRow
                    }));
                }

                // Call parent component's update handler if provided
                let result = newRow;
                if (onRowUpdate) {
                    result = await onRowUpdate(newRow, oldRow);
                }

                return result;
            } finally {
                // Clear editing ref since this row is no longer being edited
                if (editingRowIdRef.current === newRow.id) {
                    editingRowIdRef.current = null;
                }
                // Always resolve ONE pending promise per row update, even on error
                if (pendingUpdateResolvers.current.length > 0) {
                    const resolver = pendingUpdateResolvers.current.shift();
                    if (resolver) resolver();
                }
            }
        },
        [onRowUpdate]
    );
    
    React.useEffect(() => {
        if (apiRef.current) {
            apiRef.current.getModifiedRows = () => modifiedRows;
            apiRef.current.clearModifiedRows = () => {
                modifiedRowsRef.current = {};
                setModifiedRows({});
            };
            // Commit any pending edits and return all modified rows 
            // - this handles the case if the user clicks save or something before clicking off of the row
            apiRef.current.commitPendingEdits = async () => {
                const editingId = editingRowIdRef.current;

                if (editingId === null) {
                    return { ...modifiedRowsRef.current };
                }

                const updatePromise = new Promise(resolve => {
                    pendingUpdateResolvers.current.push(resolve);
                });

                apiRef.current.stopRowEditMode({ id: editingId, ignoreModifications: false });

                await updatePromise;

                return { ...modifiedRowsRef.current };
            };
        }
    }, [apiRef, modifiedRows]);
        
    // Internal row class name handler
    const internalGetRowClassName = React.useCallback((params) => {
        const modifiedClass = modifiedRows[params.id] ? 'modified-row' : '';
        const customClass = getRowClassName ? getRowClassName(params) : '';

        return `${modifiedClass} ${customClass}`.trim();
    }, [modifiedRows, getRowClassName]);

    const handleProcessRowUpdateError = React.useCallback((error) => {
        console.error('Row update error:', error);
        if (props.onRowUpdateError) {
            props.onRowUpdateError(error);
        }
    }, [props.onRowUpdateError]);

    const handleRowDoubleClick = async (params) => {
        if (apiRef.current && editMode === 'row') {
            // Stop the previously editing row (if any and different from double-clicked)
            const previousEditingId = editingRowIdRef.current;
            if (previousEditingId !== null && previousEditingId !== params.id) {
                apiRef.current.stopRowEditMode({ id: previousEditingId, ignoreModifications: false });
            }
        }

        if(isEditable){
            editingRowIdRef.current = params.id;
            apiRef.current.startRowEditMode({ id: params.id });
        } else {
            if (onRowDoubleClick) {
                onRowDoubleClick(params.row);
            } else if (!actionFlag) {
                if (onEdit && addEditAccess) {
                    onEdit(params.row);
                }
                if (onView && viewAccess) {
                    onView(params.row);
                }
            }
        }
    }

    const handleRightClick = (event) => {        
        event.preventDefault();
        if (onRowRightClick) {
            const targetRow = event.currentTarget.getAttribute('data-id');
            const row = dgRows.find(r => r.id.toString() === targetRow);
            if (row) {
                onRowRightClick(event, row, row.id);
            }
        }
    };

    const initialVisibilityModel = { ...defaultColumns };
    headCells.forEach((col, index) => {
        if (col.hide === true && !(col.id in initialVisibilityModel)) {
            initialVisibilityModel[col.id] = false;
        }
    });

    const [expandedRowId, setExpandedRowId] = React.useState(null);
    const internalApiRef = useGridApiRef();
    const apiRef = externalApiRef ? externalApiRef : internalApiRef;

    const handleCellClick: GridEventListener<'cellClick'> = (params) => {
        
        if (nestedTable && params.colDef.field === '__detail_panel_toggle__') {
            const clickedRowId = params.row.id;

            setExpandedRowId(prevExpandedRowId =>
                prevExpandedRowId === clickedRowId ? null : clickedRowId
            );
        }
    }
    
    const [selectionModel, setSelectionModel] = React.useState([]);
    const [selectionModelIds, setSelectionModelIds] = React.useState([]);
    const [deletedModelIds, setDeletedModelIds] = React.useState([]);


    //New Changes starts- Row Selection
    const [selectionModelRow, setSelectionModelRow] = React.useState([]);
    //New Changes Ends- Row Selection
    const [internalColumnVisibilityModel, setInternalColumnVisibilityModel] = React.useState(initialVisibilityModel);
    const hasExternalColumnVisibilityModel = externalColumnVisibilityModel !== undefined && externalColumnVisibilityModel !== null;
    const resolvedColumnVisibilityModel = hasExternalColumnVisibilityModel ? externalColumnVisibilityModel : internalColumnVisibilityModel;

    const handleColumnVisibilityModelChange = React.useCallback(
        (newModel) => {
            if (typeof onExternalColumnVisibilityModelChange === 'function') {
                onExternalColumnVisibilityModelChange(newModel);
            }
            if (!hasExternalColumnVisibilityModel) {
                setInternalColumnVisibilityModel(newModel);
            }
        },
        [hasExternalColumnVisibilityModel, onExternalColumnVisibilityModelChange]
    );
    useEffect(() => {
        if (hasExternalColumnVisibilityModel) {
            setInternalColumnVisibilityModel(externalColumnVisibilityModel);
        }
    }, [externalColumnVisibilityModel, hasExternalColumnVisibilityModel]);

    const clearSelectionModel = () => {
        setSelectionModel([]);
        setSelectionModelIds([]);
    };

    useEffect(() => {
        if (resetGridSelection) {
            clearSelectionModel();
        }
    }, [resetGridSelection]);


    const getDetailPanelContent = React.useCallback(({ row }) => {
        if (Object.keys(row).length === 0) {
            return null;
        }
        if (row.id === expandedRowId) {
            return <DetailPanelContentFn row={row} />;
        }
        return null; // Don't render content for other rows
    },
        [expandedRowId]
    );


    const getDetailPanelHeight = React.useCallback(() => 500, []);

    useEffect(() => {
        if (defaultValueRowsperPage) {
            setPageSize(defaultValueRowsperPage);
        }
    }, [defaultValueRowsperPage]);

    React.useEffect(() => {
        let rafId = null;
        let waitForRootId = null;
        let observer = null;
        const timeoutIds = [];
        const attributeNames = ['aria-colcount', 'aria-rowcount', 'aria-multiselectable', 'aria-labelledby'];

        const initRoleTweaks = () => {
            const dataGridRoot = apiRef?.current?.rootElementRef?.current;

            if (!dataGridRoot || !dataGridRoot.isConnected) {
                waitForRootId = requestAnimationFrame(initRoleTweaks);
                return;
            }

            if (waitForRootId !== null) {
                waitForRootId = null;
            }

            const fixAriaRoles = () => {
                if (!dataGridRoot || !dataGridRoot.isConnected) {
                    return;
                }

                const transferredAttributes = {};
                attributeNames.forEach((attr) => {
                    const value = dataGridRoot.getAttribute(attr);
                    if (value !== null) {
                        transferredAttributes[attr] = value;
                    }
                    if (dataGridRoot.hasAttribute(attr)) {
                        dataGridRoot.removeAttribute(attr);
                    }
                });

                if (dataGridRoot.hasAttribute('role')) {
                    dataGridRoot.removeAttribute('role');
                }

                const mainContainer = dataGridRoot.querySelector('.MuiDataGrid-main');
                if (mainContainer) {
                    if (mainContainer.getAttribute('role') !== 'grid') {
                        mainContainer.setAttribute('role', 'grid');
                    }
                    attributeNames.forEach((attr) => {
                        if (transferredAttributes[attr] !== undefined) {
                            mainContainer.setAttribute(attr, transferredAttributes[attr]);
                        } else if (mainContainer.hasAttribute(attr)) {
                            mainContainer.removeAttribute(attr);
                        }
                    });
                }

                const columnHeaderRow = dataGridRoot.querySelector('.MuiDataGrid-columnHeaderRow');
                if (columnHeaderRow) {
                    if (columnHeaderRow.getAttribute('role') !== 'row') {
                        columnHeaderRow.setAttribute('role', 'row');
                    }
                    if (columnHeaderRow.getAttribute('aria-rowindex') !== '1') {
                        columnHeaderRow.setAttribute('aria-rowindex', '1');
                    }
                }

                const columnHeaders = dataGridRoot.querySelectorAll('.MuiDataGrid-columnHeader');
                columnHeaders.forEach((header, index) => {
                    if (header.getAttribute('role') !== 'columnheader') {
                        header.setAttribute('role', 'columnheader');
                    }
                    if (!header.getAttribute('aria-colindex')) {
                        header.setAttribute('aria-colindex', index + 1);
                    }
                });

                const rows = dataGridRoot.querySelectorAll('.MuiDataGrid-row');
                rows.forEach((row, index) => {
                    if (row.getAttribute('role') !== 'row') {
                        row.setAttribute('role', 'row');
                    }
                    if (!row.getAttribute('aria-rowindex') || row.getAttribute('aria-rowindex') === '1') {
                        row.setAttribute('aria-rowindex', index + 2);
                    }
                });

                const cells = dataGridRoot.querySelectorAll('.MuiDataGrid-cell');
                cells.forEach(cell => {
                    if (cell.getAttribute('role') !== 'gridcell') {
                        cell.setAttribute('role', 'gridcell');
                    }
                    if (!cell.getAttribute('tabindex')) {
                        cell.setAttribute('tabindex', '-1');
                    }
                });

                const columnHeadersInner = dataGridRoot.querySelector('.MuiDataGrid-columnHeadersInner');
                if (columnHeadersInner && columnHeadersInner.getAttribute('role') !== 'rowgroup') {
                    columnHeadersInner.setAttribute('role', 'rowgroup');
                }

                const virtualScroller = dataGridRoot.querySelector('.MuiDataGrid-virtualScrollerRenderZone');
                if (virtualScroller && virtualScroller.getAttribute('role') !== 'rowgroup') {
                    virtualScroller.setAttribute('role', 'rowgroup');
                }
            };

            fixAriaRoles();
            timeoutIds.push(setTimeout(fixAriaRoles, 100));
            timeoutIds.push(setTimeout(fixAriaRoles, 500));

            observer = new MutationObserver(() => {
                if (rafId !== null) {
                    cancelAnimationFrame(rafId);
                }
                rafId = requestAnimationFrame(() => {
                    rafId = null;
                    fixAriaRoles();
                });
            });

            observer.observe(dataGridRoot, {
                childList: true,
                subtree: true,
                attributes: true,
                attributeFilter: ['class', 'role', 'aria-rowindex', 'aria-colindex', 'tabindex', ...attributeNames]
            });
        };

        initRoleTweaks();

        return () => {
            timeoutIds.forEach(clearTimeout);
            if (rafId !== null) {
                cancelAnimationFrame(rafId);
            }
            if (waitForRootId !== null) {
                cancelAnimationFrame(waitForRootId);
            }
            if (observer) {
                observer.disconnect();
            }
        };
    }, [apiRef, rows, headCells]);

    return (
        <div>
            <GlobalStyles
                styles={{
                    '.MuiPopover-root .MuiMenu-paper .MuiMenuItem-root.MuiButtonBase-root': {
                        display: 'flex !important',
                    },
                }}
            />
            <DataGridPro experimentalFeatures={{ newEditingApi: true }}
                key = {key} 
                apiRef={apiRef}
                autoHeight={autoHeight}
                loading={isLoading}
                disableMultipleColumnsSorting={true}
                components={{
                    Toolbar: ElementsDataGridToolbar,
                    ColumnMenu: ElementsColumnMenu,
                    LoadingOverlay: () => (
                        <Stack height="100%" alignItems="center" justifyContent="center" role="none presentation">
                            <CircularProgress aria-label="Loading data" />
                        </Stack>
                    ),
                    NoRowsOverlay: () => (
                        <Stack height="100%" alignItems="center" justifyContent="center">
                            {emptyRowsMessage}
                        </Stack>
                    ),
                    NoResultsOverlay: () => (
                        <Stack height="100%" alignItems="center" justifyContent="center">
                            {emptyResultsMessage}
                        </Stack>
                    )
                }}
                componentsProps={{
                    toolbar: {
                        selectionModel,
                        selectionModelIds,
                        onEdit,
                        onDelete, 
                        deleteDisable,
                        onEnable,
                        onView,
                        onCopy,
                        onShare, 
                        rows,
                        trackingLabel,
                        selectionModelRow,
                        addEditAccess, shareAccess, viewAccess, onAdd, isDelete, showDownload,
                        onMoreActions,
                        moreActionsAccess, 
                        onWorkflowAction,
                        hideFooterSelectedRowCount,
                        selectionModelChanged,
                        approvalActions,
                        approvalActionsAccess,
                        deleteConfirmTitle,
                    },
                    row: { 
                       onContextMenu: handleRightClick
                    },
                    basePopper: {
                        disablePortal: false,
                        disableScrollLock: true,                        
                        BackdropProps: {
                            invisible: true, 
                        },
                        sx: {
                            // Fix singleSelect dropdown display
                            '& .MuiButtonBase-root': {
                                display: 'flex !important',
                            },
                            '&.MuiDataGrid-menu .MuiPaper-root': {
                                width: '188px',
                                backgroundColor: '~FFFFFF',
                                border: '1px solid rgba(210, 210, 210, 0.58)',
                                boxShadow: '0px 0px 6px rgba(211, 211, 211, 0.74)',
                                borderRadius: '3px',
                                '& .MuiDataGrid-menuList': {
                                    '& .MuiMenuItem-root': {
                                        display: 'block-flex',
                                        paddingLeft: '16px',
                                        fontSize: '14px',
                                        fontWeight: '400',
                                        color: '#646569'
                                    },
                                    '& .MuiMenuItem-root:hover': {
                                        color: '#000000',
                                        backgroundColor: '#FBF4E5'
                                    }
                                },
                            },
                            '& .MuiButtonBase-root': {
                                display: 'flex !important',
                            },
                            '&.MuiDataGrid-panel .MuiPaper-root': {
                                '& .MuiDataGrid-panelHeader': {
                                    padding: '16px 16px 0px 16px',
                                    '& .MuiInputLabel-standard': {
                                        color: '#646569',
                                        fontSize: '14px',
                                        fontWeight: '400'
                                    },
                                    '& .MuiInput-input': {
                                        color: '#000000',
                                        fontSize: '14px',
                                        fontWeight: '400'
                                    }
                                },
                                '& .MuiDataGrid-panelContent': {
                                    padding: '16px 16px 16px 16px',
                                    '& .MuiSwitch-sizeSmall': {
                                        width: '60px'
                                    },
                                    '& .MuiSwitch-switchBase': {
                                        color: '#96989A'
                                    },
                                    '& .MuiSwitch-switchBase+.MuiSwitch-track': {
                                        backgroundColor: '#E2E2E2',
                                        opacity: '1',
                                        transform: 'translateX(-16px)'
                                    },
                                    '& .MuiSwitch-switchBase.Mui-checked': {
                                        color: '#0A66C2'
                                    },
                                    '& .MuiSwitch-switchBase.Mui-checked+.MuiSwitch-track': {
                                        backgroundColor: '#E3ECF5',
                                        opacity: '1'
                                    },
                                    '& .MuiFormControlLabel-label': {
                                        color: '#646569',
                                        fontSize: '14px',
                                        fontWeight: '400'
                                    },
                                    '& .MuiDataGrid-filterForm': {
                                        '& .MuiIconButton-sizeSmall:hover': {
                                            backgroundColor: '#FBF4E5'
                                        },
                                        '& .MuiDataGrid-filterFormColumnInput, .MuiDataGrid-filterFormOperatorInput': {
                                            marginRight: '16px'
                                        },
                                        '& .MuiInputLabel-standard': {
                                            fontSize: '16px',
                                            fontWeight: '700',
                                            color: '#646569'
                                        },
                                        '& .MuiInput-input': {
                                            fontSize: '14px',
                                            fontWeight: '400',
                                            color: '#646569'
                                        },
                                        '& .MuiNativeSelect-select': {
                                            paddingLeft: '2px',
                                            paddingRight: '24px',
                                            minWidth: '16px'
                                        }
                                    },

                                },
                                '& .MuiDataGrid-panelFooter': {
                                    padding: '0px 16px 16px 16px',
                                    '& .MuiButton-root': {
                                        backgroundColor: '#E3ECF5',
                                        color: '#0A66C2',
                                        border: '1px solid #E3ECF5',
                                        borderRadius: '4px',
                                        padding: '0px 10px 0px 10px',
                                        minHeight: '28px',
                                        fontWeight: '600',
                                        fontSize: '12px',
                                        textTransform: 'capitalize'
                                    },
                                }
                            }
                        }
                    },
                    pagination: {
                        SelectProps: {
                            MenuProps: {
                                sx: {
                                    '.MuiList-padding': {
                                        padding: '1px 1px 1px 1px'
                                    },
                                    '.MuiTablePagination-menuItem': {
                                        display: 'block-flex',
                                        paddingLeft: '8px',
                                        fontSize: '14px',
                                        fontWeight: '400',
                                        color: '#646569'
                                    },
                                    '.MuiTablePagination-menuItem:hover, .MuiTablePagination-menuItem.Mui-selected:hover': {
                                        color: '#000000',
                                        backgroundColor: '#E6F5F9',
                                        border: '1px solid #0A66C2',
                                    },
                                    '.MuiTablePagination-menuItem.Mui-selected': {
                                        backgroundColor: '#FFFFFF'
                                    }
                                }
                            }
                        }
                    }
                }}
                localeText={{
                    toolbarColumns: "",
                    toolbarFilters: ""
                }}
                isRowSelectable={(params) => {
                    if (isRowSelectable) {
                        return isRowSelectable(params.row);
                    }
                    return true;
                }}
                onRowClick={handleRowClick}
                processRowUpdate={handleProcessRowUpdate}
                onProcessRowUpdateError={handleProcessRowUpdateError}
                editMode={editMode}
                onRowDoubleClick={handleRowDoubleClick}
                disableMultipleSelection={!multiSelect}
                checkboxSelection={!nestedTable && !isLookup && !hideCheckBox}
                getRowClassName={internalGetRowClassName}
                getDetailPanelHeight={nestedTable ? (DetailPanelHeightCustom ? DetailPanelHeightCustom : getDetailPanelHeight) : undefined}
                getDetailPanelContent={nestedTable ? getDetailPanelContent : undefined}
                onCellClick={handleCellClick}
                detailPanelExpandedRowIds={expandedRowId != null ? [expandedRowId] : []}
                columns={dgColumns}
                rows={dgRows}
                initialState={initialSorting}

                page={page}
                onPageChange={(newPage) => setPage(newPage)}

                pagination={pagination}
                hideFooterRowCount={!pagination}
                hideFooterSelectedRowCount={hideFooterSelectedRowCount}
                rowsPerPageOptions={[20, 50, 100]}
                pageSize={pageSize}
                onPageSizeChange={(newPageSize) => setPageSize(newPageSize)}
                selectionModel={selectionModel}
                onSelectionModelChange={(newSelectionModel) => { 
                   
                    let selectedIndexes = [];
                    if (newSelectionModel.length > 1 && !multiSelect) {
                       const latestSelection = newSelectionModel[newSelectionModel.length - 1];
                       setSelectionModel([latestSelection]);
                       selectedIndexes = new Set([latestSelection])
                    }
                    else {
                        setSelectionModel(newSelectionModel);
                        selectedIndexes = new Set(newSelectionModel)
                    }
                    const selectedRows = dgRows.filter((row) =>
                        selectedIndexes.has(row.id)
                    )
                    let ids = []
                    selectedRows.forEach((element) => {
                        ids.push(Object.values(element)[1])
                    })
                    setSelectionModelIds(ids);
                    //New Changes starts- Row Selection
                    setSelectionModelRow(selectedRows)
                    if (typeof selectionModelChanged === 'function') {
                        selectionModelChanged(selectedRows);
                    }
                    if (onRowSelect && selectedRows.length > 0) {
                        onRowSelect(selectedRows[0]);
                    }
                    //New Changes ends- Row Selection
                }}
                columnVisibilityModel={resolvedColumnVisibilityModel}
                onColumnVisibilityModelChange={handleColumnVisibilityModelChange}
                sx={{
                    width: '100%',
                    height: 160 + Math.min(maxVisibleRows, Math.min(pageSize, dgRows.length + 1)) * 52,
                    minHeight: 250,
                    background: '#FFFFFF',
                    border: '1px solid rgba(210, 210, 210, 0.58)',
                    boxShadow: '0px 0px 6px rgba(211, 211, 211, 0.74)',
                    borderRadius: '3px',
                    fontSize: '16px',
                    ...sxOverride,
                    ...( !multiSelect && {
                        '& .MuiDataGrid-columnHeaderCheckbox': {
                           visibility: 'hidden !important',
                        },
                    }),
                    '& .MuiDataGrid-cell--editing input[type=number]::-webkit-inner-spin-button': {
                        WebkitAppearance: 'auto !important',
                        opacity: 1,
                    },
                    '& .MuiDataGrid-cell--editing input[type=number]::-webkit-outer-spin-button': {
                        WebkitAppearance: 'auto !important',
                        opacity: 1,
                    },
                    '& .MuiDataGrid-cell--editing input[type=number]': {
                        MozAppearance: 'number-input',
                    },
                    // Show date and datetime picker icons
                    '& .MuiDataGrid-cell--editing input[type=date]::-webkit-calendar-picker-indicator': {
                        display: 'block !important',
                        opacity: 1,
                        cursor: 'pointer',
                        WebkitAppearance: 'auto',
                    },
                    '& .MuiDataGrid-cell--editing input[type=datetime-local]::-webkit-calendar-picker-indicator': {
                        display: 'block !important',
                        opacity: 1,
                        cursor: 'pointer',
                        WebkitAppearance: 'auto',
                    },
                    '& .MuiDataGrid-cell--editing input[type=date]': {
                        appearance: 'auto !important',
                        WebkitAppearance: 'auto !important',
                    },
                    '& .MuiDataGrid-cell--editing input[type=datetime-local]': {
                        appearance: 'auto !important',
                        WebkitAppearance: 'auto !important',
                    },
                    // Modified row styling for unsaved changes
                    '& .modified-row': {
                        backgroundColor: '#E0F7E1  !important',
                    },
                    '& .modified-row:hover': {
                        backgroundColor: '#E0F7E1  !important',
                    },                    
                    '.MuiDataGrid-toolbarContainer': {
                        justifyContent: 'flex-end',
                        padding: '5px 20px 2px 20px',
                        borderBottom: '1px solid rgba(224, 224, 224, 1)',
                        '& .MuiButton-root': {
                            minWidth: '38px',
                            minHeight: '38px',
                            '& .MuiButton-startIcon': {
                                color: '#646569'
                            },
                            '& .MuiButton-iconSizeSmall': {
                                marginLeft: '-2px',
                                marginRight: '-2px'
                            }
                        },
                        '& .MuiButton-root:hover': {
                            backgroundColor: "#FBF4E5",
                            borderRadius: "50px",
                            height: "38px",
                            width: "38px",
                            '& svg': {
                                filter: 'brightness(0) saturate(100%)'
                            }
                        },
                        '& .MuiButtonBase-root.Mui-disabled': {
                            backgroundColor: 'transparent !important',
                            color: "#646464 !important"
                        },
                        '& .RowSelectedCount': {
                            fontWeight: '500',
                            fontSize: '14px',
                            color: '#646569',
                            marginRight: 'auto',
                            paddingTop: '7px',
                            paddingLeft: '14px'
                        },
                        '& .disableDeleteButton': {
                            pointerEvents: 'none',
                        },
                    },
                    '.MuiDataGrid-columnHeaders': {
                        padding: '0px 16px 0px 16px',
                        borderBottomColor: `${BrandingColors.brightOrange}`,
                        fontFamily: 'FiraSans-Medium, sans-serif',
                        '& .MuiDataGrid-columnHeader': {
                            backgroundColor: '#FFFFFF'
                        }
                    },
                    '.MuiDataGrid-iconButtonContainer, .MuiDataGrid-menuIcon': {
                        '.MuiIconButton-root': {
                            height: '24px',
                            width: '24px',
                        },
                        '.MuiIconButton-root:hover': {
                            backgroundColor: '#FBF4E5',
                            '& svg': {
                                filter: 'brightness(0) saturate(100%)'
                            }
                        }
                    },
                    '.MuiDataGrid-main': {
                        padding: '0px 16px 0px 16px'
                    },
                    '.MuiDataGrid-columnHeader': {
                        boxSizing: 'border-box',
                        fontFamily: 'FiraSans-Medium, sans-serif'
                    },
                    '.MuiDataGrid-columnHeaderTitleContainer': {
                        justifyContent: 'flex-start',
                        fontFamily: 'FiraSans-Medium, sans-serif'
                    },
                    '.MuiDataGrid-columnHeaderTitle': {
                        color: "#424B5C",
                        fontWeight: '500',                        
                        fontFamily: 'FiraSans-Medium, sans-serif'
                    },
                    '.MuiDataGrid-cell, .MuiDataGrid-cell--number, .MuiDataGrid-cell *:not(svg), .MuiDataGrid-columnHeaderTitle': {
                        fontSize: '16px !important',
                    },
                    '.MuiDataGrid-cellContent': {
                        color: "#424B5C",
                        fontWeight: '400'
                    },
                    '.MuiDataGrid-row.Mui-selected': {
                        backgroundColor: `${BrandingColors.hoverOrangeCustom}`,
                        '& .MuiDataGrid-cell': {
                            '& .MuiDataGrid-cellContent': {
                                color: '#000000'
                            }
                        }
                    },
                    '.MuiDataGrid-rowCount': {
                        float: 'right'
                    },
                    '.MuiDataGrid-row:hover, .MuiDataGrid-row.Mui-selected:hover': {
                        backgroundColor: '#E6F5F9'
                    },
                    // Editable cell indicators on row hover (not when selected or editing)
                    '.MuiDataGrid-row:hover:not(.Mui-selected):not(.MuiDataGrid-row--editing) .editable-cell': {
                        position: 'relative',
                    },
                    // Editable Grid Styles - Dropdown arrow for singleSelect fields on hover
                    '.MuiDataGrid-row:hover:not(.Mui-selected):not(.MuiDataGrid-row--editing) .editable-select': {
                        '&::after': {
                            content: '""',
                            position: 'absolute',
                            right: '8px',
                            top: '50%',
                            transform: 'translateY(-50%)',
                            width: '20px',
                            height: '20px',
                            backgroundImage: `url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24'%3E%3Cpath fill='%23646569' d='M7 10l5 5 5-5z'/%3E%3C/svg%3E")`,
                            backgroundSize: 'contain',
                            backgroundRepeat: 'no-repeat',
                            pointerEvents: 'none',
                        }
                    },
                    // Editable Grid Styles - Pencil icon for text fields on hover
                    '.MuiDataGrid-row:hover:not(.Mui-selected):not(.MuiDataGrid-row--editing) .editable-text': {
                        '&::after': {
                            content: '""',
                            position: 'absolute',
                            right: '8px',
                            top: '50%',
                            transform: 'translateY(-50%)',
                            width: '16px',
                            height: '16px',
                            backgroundImage: `url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24'%3E%3Cpath fill='%23646569' d='M3 17.25V21h3.75L17.81 9.94l-3.75-3.75L3 17.25zM20.71 7.04c.39-.39.39-1.02 0-1.41l-2.34-2.34c-.39-.39-1.02-.39-1.41 0l-1.83 1.83 3.75 3.75 1.83-1.83z'/%3E%3C/svg%3E")`,
                            backgroundSize: 'contain',
                            backgroundRepeat: 'no-repeat',
                            pointerEvents: 'none',
                        }
                    },
                    // Editable Grid Styles - Calendar icon for date fields on hover
                    '.MuiDataGrid-row:hover:not(.Mui-selected):not(.MuiDataGrid-row--editing) .editable-date': {
                        '&::after': {
                            content: '""',
                            position: 'absolute',
                            right: '8px',
                            top: '50%',
                            transform: 'translateY(-50%)',
                            width: '16px',
                            height: '16px',
                            backgroundImage: `url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24'%3E%3Cpath fill='%23646569' d='M20 3h-1V1h-2v2H7V1H5v2H4c-1.1 0-2 .9-2 2v16c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 18H4V8h16v13z'/%3E%3C/svg%3E")`,
                            backgroundSize: 'contain',
                            backgroundRepeat: 'no-repeat',
                            pointerEvents: 'none',
                        }
                    },
                    '[data-testid="CheckBoxOutlineBlankIcon"]': {
                        color: '#646569'
                    },
                    '.MuiMenu-paper .MuiMenu-list': {
                        fontWeight: '700',
                        display: 'inline-block'
                    },
                    '.MuiDataGrid-footerContainer': {
                        padding: '10px 16px 16px 16px',
                        '& .MuiDataGrid-selectedRowCount, & .MuiTablePagination-selectLabel, & .MuiTablePagination-displayedRows, & .MuiTablePagination-select': {
                            fontWeight: '500',
                            fontSize: '14px',
                            color: '#646569'
                        },
                        '& .MuiTablePagination-select:hover, .MuiTablePagination-select:focus': {
                            backgroundColor: '#E6F5F9'
                        },
                        '& .MuiIconButton-sizeMedium': {
                            height: '34px',
                            width: '34px'
                        },
                        '& .MuiIconButton-sizeMedium:hover': {
                            backgroundColor: '#E6F5F9'
                        },
                        '& .MuiButtonBase-root.Mui-disabled': {
                            cursor: 'default',
                            pointerEvents: 'none',
                            backgroundColor: 'transparent !important',
                            opacity: '0.38'
                        }
                    },
                    '.MuiTablePagination-menuItem': {
                        display: 'block-flex'
                    }
                }}
            />
        </div>
    )
}
